const state = {
    currentPage: 1,
    pageSize: 5,
    selectedStatus: 'ALL',
    ticketSelectedStatus: 'ALL'
};

const mutations = {
    setCurrentPage(state, page) {
        state.currentPage = page;
    },
    setPageSize(state, size) {
        state.pageSize = size;
    },
    setSelectedStatus(state, status) {
        state.selectedStatus = status;
    },
    setTicketSelectedStatus(state, status) {
        state.ticketSelectedStatus = status;
    },
    resetPagination(state) {
        state.currentPage = 1;
        state.pageSize = 5;
        state.selectedStatus = 'ALL';
        state.ticketSelectedStatus = 'ALL';
    }
};

const actions = {
    updateCurrentPage({ commit }, page) {
        commit('setCurrentPage', page);
    },
    updatePageSize({ commit }, size) {
        commit('setPageSize', size);
    },
    updateSelectedStatus({ commit }, status) {
        commit('setSelectedStatus', status);
    },
    updateTicketSelectedStatus({ commit }, status) {
        commit('setTicketSelectedStatus', status);
    },
    resetOrderState({ commit }) {
        commit('resetPagination');
    }
};

const getters = {
    getCurrentPage(state) {
        return state.currentPage;
    },
    getPageSize(state) {
        return state.pageSize;
    },
    getSelectedStatus(state) {
        return state.selectedStatus;
    },
    getTicketSelectedStatus(state) {
        return state.ticketSelectedStatus;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}; 